import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-keyboard-backspace",
  "use": "icon-keyboard-backspace-usage",
  "viewBox": "0 0 16 13",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 13\" id=\"icon-keyboard-backspace\"><path d=\"M2.11 6.467h12.5\" stroke=\"param(outline) #000\" stroke-linecap=\"square\" /><path d=\"M7 12.326l-6-6L6.326 1\" stroke=\"param(outline) #000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol